export const config = {
  apiUrl: process.env.REACT_APP_JOB_APP_API_URL,
  altImg: "images/no_avatar_profile.jpg",
  baseUrl: process.env.REACT_APP_JOB_APP_BASE_URL,
  altInvImg: "images/inv_img.jpeg",
  mainUrl: process.env.REACT_APP_JOB_APP_MAIN_URL,
  facebookAppId: process.env.REACT_APP_JOB_APP_FACEBOOK_APP_ID,
  googleAppId: process.env.REACT_APP_JOB_APP_GOOGLE_APP_ID,
  _api: path => {
    return config.apiUrl + "/api/" + path;
  },
  dsn: process.env.REACT_APP_JOB_APP_DSN
};

